<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-7 col-sm-12 col-xs-12">
                        <h4 class="card-title">Автоматични рецепти</h4>
                    </div>
                    <div class="col-md-5 col-sm-12 col-xs-12 text-right">
                        <button
                                routerLink="/master/auto/recipes/create"
                                type="button"
                                class="buy-subscription btn btn-success btn-icon-text">
                            <i class="ti-plus btn-icon-prepend"></i>
                            Създаване на конфигурация
                        </button>
                    </div>
                </div>

                <div class="row" style="padding-top: 15px;">
                    <div class="col-12">
                        <div class="table-responsive">
                            <table *ngIf="configs" datatable [dtOptions]="dtOptions" class="table">
                                <thead>
                                <tr class="bg-primary text-white">
                                    <th>#</th>
                                    <th>Статус</th>
                                    <th>От Дата</th>
                                    <th>До Дата</th>
                                    <th>Брой Рецепти</th>
                                    <th>Настройки</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr class="row-profile" *ngFor="let config of configs; let i = index">
                                    <td>{{ i + 1 }}</td>
                                    <td>
                                        <ng-container *ngIf="config.is_active">
                                            <i class="check fa fa-check-circle"></i>
                                            Активен
                                        </ng-container>
                                        <ng-container *ngIf="!config.is_active">
                                            <i class="times fa fa-times-circle"></i>
                                            Неактивен
                                        </ng-container>
                                    </td>
                                    <td>{{ formatDate(config.dateFrom) }}</td>
                                    <td>{{ formatDate(config.dateTo) }}</td>
                                    <td>{{ config.recipes_count}} бр.</td>

                                    <td>
                                        <ng-container *ngIf="config.is_active">
                                            <button
                                                    (click)="openConfig(config.id)"
                                                    type="button"
                                                    class="btn-settings btn btn-sm btn-secondary btn-icon-text">
                                                <i class="ti-eye btn-icon-prepend"></i>
                                                Преглед
                                            </button>
                                        </ng-container>

                                        <ng-container *ngIf="!config.is_active">
                                            <button
                                                    (click)="openConfig(config.id)"
                                                    type="button"
                                                    class="btn-settings btn btn-sm btn-secondary btn-icon-text">
                                                <i class="ti-pencil btn-icon-prepend"></i>
                                                Редактирай
                                            </button>

                                            <button
                                                    (click)="deleteConfig(config.id)"
                                                    type="button"
                                                    class="btn-delete btn btn-sm btn-danger btn-icon-text">
                                                <i class="ti-trash btn-icon-prepend"></i>
                                                Изтрий
                                            </button>
                                        </ng-container>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
